<script>
    import Icon from '../icons/Icon.svelte';

    export let subscriptionStatus = 'active';
    export let monthlyPrice = 97.00;
    export let supportWhatsappUrl = '';
    export let isSupportAvailable = false;
    export let storeName = '';
</script>

<div class="tab-pane">
    <!-- 1. Plano & Assinatura SaaS -->
    <section class="settings-card plan-card">
        <div class="plan-header">
            <div class="plan-badge-box">
                <Icon name="award" size={28} />
            </div>
            <div class="plan-info">
                <span class="plan-type">PLANO ATIVO</span>
                <h3>MataFome SaaS • Pro & Delivery</h3>
                <p>Acesso completo ao Cardápio Digital, Painel do Atendente, KDS, Gestor de Motoboys PWA e Robô no WhatsApp.</p>
            </div>
            <div class="plan-price-box">
                <span class="price-val">R$ {parseFloat(monthlyPrice || 97).toFixed(2)}</span>
                <span class="price-period">/mês</span>
            </div>
        </div>

        <div class="plan-details-grid">
            <div class="plan-stat">
                <span class="stat-label">Status da Assinatura</span>
                <span class="stat-value {subscriptionStatus === 'active' ? 'status-active' : 'status-pending'}">
                    ● {subscriptionStatus === 'active' ? 'Ativo & Regularizado' : 'Pagamento Pendente'}
                </span>
            </div>
            <div class="plan-stat">
                <span class="stat-label">Estabelecimento</span>
                <span class="stat-value">{storeName || 'Sua Loja'}</span>
            </div>
            <div class="plan-stat">
                <span class="stat-label">Atualizações Automáticas</span>
                <span class="stat-value text-green">Inclusas via Nuvem</span>
            </div>
        </div>
    </section>

    <!-- 2. Suporte Oficial do MataFome -->
    <section class="settings-card support-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="whatsapp" size={18} />
                <h4>Canal Direto de Suporte & Atendimento</h4>
            </div>
            <span class="card-subtitle">Precisa de ajuda com impressora, configuração de cardápio ou pagamentos? Fale com a equipe oficial.</span>
        </div>

        <div class="support-content">
            <div class="support-info-box">
                <p>Nossa equipe de suporte técnico e engenharia atende de segunda a sábado em horário comercial para garantir que sua operação nunca pare.</p>
                <div class="support-badges">
                    <span class="support-pill">
                        <Icon name="check-circle" size={12} />
                        Atendimento Humano
                    </span>
                    <span class="support-pill">
                        <Icon name="zap" size={12} />
                        Suporte via WhatsApp
                    </span>
                </div>
            </div>

            {#if isSupportAvailable && supportWhatsappUrl}
                <a
                    href={supportWhatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    class="btn-support-whatsapp"
                >
                    <Icon name="whatsapp" size={18} />
                    <span>Falar com o Suporte Oficial</span>
                </a>
            {:else}
                <div class="support-fallback">
                    <span>Suporte disponível através do seu gestor de conta ou e-mail de atendimento.</span>
                </div>
            {/if}
        </div>
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .settings-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 22px 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .plan-card {
        background: linear-gradient(135deg, #FFF7ED 0%, #FFFFFF 100%);
        border: 1px solid #FED7AA;
        box-shadow: 0 2px 8px rgba(234, 88, 12, 0.06);
    }

    .plan-header {
        display: flex;
        align-items: center;
        gap: 18px;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }

    .plan-badge-box {
        width: 52px;
        height: 52px;
        border-radius: 12px;
        background: #FFEDD5;
        color: #EA580C;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .plan-info {
        flex: 1;
        min-width: 220px;
    }

    .plan-type {
        font-size: 0.68rem;
        font-weight: 700;
        color: #EA580C;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        display: block;
        margin-bottom: 2px;
    }

    .plan-info h3 {
        font-size: 1.15rem;
        font-weight: 700;
        color: #0F172A;
        margin: 0 0 4px 0;
    }

    .plan-info p {
        font-size: 0.82rem;
        color: #64748B;
        margin: 0;
        line-height: 1.45;
    }

    .plan-price-box {
        text-align: right;
    }

    .price-val {
        font-size: 1.5rem;
        font-weight: 800;
        color: #16A34A;
    }

    .price-period {
        font-size: 0.78rem;
        color: #64748B;
    }

    .plan-details-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 12px;
        border-top: 1px solid #F1F5F9;
        padding-top: 16px;
    }

    .plan-stat {
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    .stat-label {
        font-size: 0.72rem;
        color: #64748B;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        font-weight: 600;
    }

    .stat-value {
        font-size: 0.88rem;
        font-weight: 700;
        color: #0F172A;
    }

    .status-active {
        color: #16A34A;
    }

    .status-pending {
        color: #D97706;
    }

    .text-green {
        color: #16A34A;
    }

    .card-header {
        margin-bottom: 16px;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0F172A;
    }

    .card-title-group h4 {
        font-size: 0.98rem;
        font-weight: 700;
        margin: 0;
        color: #0F172A;
    }

    .card-subtitle {
        font-size: 0.82rem;
        color: #64748B;
        display: block;
        margin-top: 4px;
    }

    .support-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        flex-wrap: wrap;
    }

    .support-info-box {
        flex: 1;
        min-width: 240px;
    }

    .support-info-box p {
        font-size: 0.84rem;
        color: #475569;
        margin: 0 0 10px 0;
        line-height: 1.45;
    }

    .support-badges {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .support-pill {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 0.74rem;
        background: #F1F5F9;
        color: #475569;
        padding: 5px 12px;
        border-radius: 6px;
        border: 1px solid #E2E8F0;
        font-weight: 500;
    }

    .btn-support-whatsapp {
        background: #16A34A;
        color: #fff;
        padding: 10px 20px;
        border-radius: 8px;
        font-size: 0.86rem;
        font-weight: 700;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 2px 6px rgba(22, 163, 74, 0.25);
        transition: all 0.2s;
    }

    .btn-support-whatsapp:hover {
        background: #15803D;
    }

    .support-fallback {
        font-size: 0.8rem;
        color: #64748B;
    }
</style>
